import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

export const Container = styled.div<{
  raceEnded?: boolean;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  ${({ raceEnded }) =>
    raceEnded
      ? `background-color: ${buildColor("navy", "700")};`
      : `background-color: ${buildColor("blue", "950")};`}
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  margin: 8px 0 0;
`;

export const Placeholder = styled.div`
  height: 1px;
  width: 5%;
`;
